function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1758",
  transform: "translate(-375 -387)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 11,
  fill: "#55b154",
  "data-name": "Ellipse 72",
  transform: "translate(375 387)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M390.656 400.995h-.559v-3.517a4.432 4.432 0 00-2.925-4.27 1.175 1.175 0 10-2.348 0 4.432 4.432 0 00-2.925 4.27v3.517h-.559a.342.342 0 100 .683h3.4a.34.34 0 00-.022.116 1.284 1.284 0 102.562 0 .337.337 0 00-.022-.116h3.4a.342.342 0 100-.683zm-4.659-8.31a.5.5 0 01.459.365 3.7 3.7 0 00-.918 0 .5.5 0 01.459-.365zm-3.417 4.793a3.613 3.613 0 013.417-3.774 3.613 3.613 0 013.417 3.774v3.517h-6.834zm4.015 4.316a.6.6 0 11-1.2 0 .34.34 0 00-.022-.116h1.239a.337.337 0 00-.017.116z",
  "data-name": "Path 1167"
}));

function SvgIconNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), _ref);
}

export default SvgIconNotification;